package com.anjuros.website.templates.template5.sections

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.components.shared.AnjurosImage
import com.anjuros.website.components.shared.AnjurosText
import com.anjuros.website.templates.template2.modules.Template2Theme
import com.anjuros.website.templates.template2.modules.getColor
import com.anjuros.website.templates.template5.components.Template5SectionTitle
import com.anjuros.website.templates.template5.modules.Template5Category
import com.anjuros.website.templates.template5.modules.Template5HeaderItem
import com.anjuros.website.templates.template5.modules.Template5Product
import com.anjuros.website.templates.template5.modules.Template5Theme
import com.anjuros.website.templates.template5.modules.getColor
import com.anjuros.website.templates.template5.styles.ProductCardMaxWidthStyle
import com.anjuros.website.templates.template5.styles.ProductRowPercStyle
import com.anjuros.website.templates.template5.styles.ProductSingleCardWidthStyle
import com.anjuros.website.templates.template5.styles.Template5CarouselArrowStyle
import com.anjuros.website.templates.template5.styles.Template5CategoryButtonStyle
import com.anjuros.website.templates.template5.styles.Template5ProductCardStyle
import com.anjuros.website.templates.template5.styles.Template5ProductCategoryStyle
import com.anjuros.website.templates.template5.styles.Template5ProductImageStyle
import com.anjuros.website.templates.template5.styles.Template5ProductTitleStyle
import com.anjuros.website.templates.template5.util.ResKey
import com.varabyte.kobweb.compose.css.Cursor

import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.WhiteSpace
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.objectFit
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.whiteSpace
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.framework.annotations.DelicateApi
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.components.layout.numColumns
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.breakpoint.displayIfAtLeast
import com.varabyte.kobweb.silk.style.breakpoint.displayUntil
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import kotlinx.browser.document
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.rgb
import org.jetbrains.compose.web.css.rgba
import org.jetbrains.compose.web.dom.H3
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text
import org.w3c.dom.HTMLElement
import org.w3c.dom.SMOOTH
import org.w3c.dom.ScrollBehavior
import org.w3c.dom.ScrollToOptions
import org.w3c.dom.events.Event

@Composable
fun Template5ProductSection(
    largeProductNumber:Int = 4
){
    Box(
        modifier = Modifier
            .id(Template5HeaderItem.PRODUCTS.id)
            .fillMaxSize(),
        contentAlignment = Alignment.Center
    ) {

        Template5ProductsSection()



    }
}

@Composable
fun Template5ProductsSection() {

    var selectedCategory by remember {
        mutableStateOf(Template5Category.CATEGORY1)
    }


    Column(
        modifier = Template5ProductTitleStyle.toModifier()

            .backgroundColor(Colors.White),
        verticalArrangement = Arrangement.Center,
        horizontalAlignment = Alignment.CenterHorizontally
    ) {

        Template5SectionTitle(
            badge = ResKey.TEMPLATE5_PRODUCTS_BADGE,
            title = ResKey.TEMPLATE5_PRODUCTS_MAIN_TITLE,
            text = ResKey.TEMPLATE5_PRODUCTS_DESC
        )

        Template5CategorySelector(
            selected = selectedCategory,
            onSelected = {
                if (selectedCategory != it) {

                    selectedCategory = it

                    document
                        .getElementById("scrollableContainer")
                        ?.scrollTo(0.0, 0.0)


                }
            }
        )

        Spacer()
        H3(
            attrs = Modifier
                .fontSize(34.px)
                .fontWeight(FontWeight.Bold)
                .color(Template5Theme.Primary.getColor())
                .margin(top = 25.px, bottom = 20.px)
                .toAttrs()
        ) {
            Text(LocalText(selectedCategory.title))
        }

        Template5ProductsCarousel(
            category = selectedCategory
        )

    }

}


@Composable
private fun Template5CategorySelector(
    selected: Template5Category,
    onSelected: (Template5Category) -> Unit
) {


    SimpleGrid(
        numColumns = numColumns(base = 2, lg=Template5Category.entries.size),
        modifier = Template5ProductCategoryStyle.toModifier()
            .overflow(Overflow.Auto)

            .gap(14.px)
            .styleModifier {
                property("scrollbar-width", "none")
                property("-ms-overflow-style", "none")
            }
    ) {

        Template5Category.entries.forEach { category ->

            Template5CategoryButton(
                category = category,
                selected = category == selected
            ) {
                onSelected(category)
            }

        }

    }

}

@Composable
private fun Template5CategoryButton(
    category: Template5Category,
    selected: Boolean,
    onClick: () -> Unit
) {

    Box(
        modifier = Modifier
            .then(Template5CategoryButtonStyle.toModifier())
            .backgroundColor(
                if (selected)
                    Template5Theme.Secondary.getColor()
                else
                    Colors.White
            )
            .border(
                1.px,
                LineStyle.Solid,
                if (selected)
                    Template5Theme.Secondary.getColor()
                else
                    rgb(235, 225, 225)
            )
            .padding(
                left = 24.px,
                right = 24.px,
                top = 14.px,
                bottom = 14.px
            )
            .cursor(Cursor.Pointer)
            .onClick { onClick() }
    ) {

        P(
            attrs = Modifier
                .align(Alignment.Center)
                .textAlign(TextAlign.Center)
                .fontSize(16.px)
                .fontWeight(FontWeight.Medium)
                .whiteSpace(WhiteSpace.NoWrap)
                .color(
                    if (selected)
                        Colors.White
                    else
                        Template5Theme.Primary.getColor()
                )
                .margin(0.px)
                .toAttrs()
        ) {
            Text(LocalText(category.title))
        }

    }

}

@Composable
private fun Template5ProductCard(
    modifier: Modifier = Modifier,
    product: Template5Product,
) {

    Box(
        modifier = modifier
            .then(Template5ProductCardStyle.toModifier())
            .backgroundColor(Colors.White)
            .borderRadius(28.px)
            .overflow(Overflow.Hidden)
            .border(
                width = 1.px,
                color = Template5Theme.Primary.rgb,
                style = LineStyle.Solid
            )
            .boxShadow(
                4.px, 4.px, 15.0.px, 2.0.px, color =  rgba(0, 0, 0, 0.4), false
            )



    ) {

        Column(
            modifier = Modifier.fillMaxSize() // fills the whole card
        ) {

            //----------------------------------------------------
            // IMAGE
            //----------------------------------------------------

            Box(
                modifier = Modifier
                    .fillMaxWidth()
                    .height(250.px)
            ) {
                AnjurosImage(
                    modifier = Template5ProductImageStyle.toModifier()
                        .fillMaxSize()
                        .objectFit(ObjectFit.Cover),
                    src = product.image,
                    alt = LocalText(product.title)
                )
            }

            //----------------------------------------------------
            // CONTENT
            //----------------------------------------------------

            Column(
                modifier = Modifier
                    .fillMaxWidth()
                    .weight(1f)          // <-- fills remaining height
                    .padding(24.px),
                verticalArrangement = Arrangement.SpaceBetween
            ) {

                Column {

                    H3(
                        attrs = Modifier
                            .fontSize(24.px)
                            .fontWeight(FontWeight.Bold)
                            .color(Template5Theme.Primary.getColor())
                            .margin(bottom = 4.px) // smaller gap
                            .toAttrs()
                    ) {
                        Text(LocalText(product.title))
                    }

                    P(
                        attrs = Modifier
                            .fontSize(15.px)
                            .lineHeight(1.6)
                            .color(rgb(120, 120, 120))
                            .margin(0.px)
                            .toAttrs()
                    ) {
                        Text(LocalText(product.description))
                    }
                }

                Column {

                    P(
                        attrs = Modifier
                            .fontSize(13.px)
                            .color(rgb(170, 170, 170))
                            .margin(0.px)
                            .toAttrs()
                    ) {
                        Text(LocalText(ResKey.TEMPLATE5_PRODUCTS_FROM))
                    }

                    P(
                        attrs = Modifier
                            .fontSize(28.px)
                            .fontWeight(FontWeight.Bold)
                            .color(Template5Theme.Secondary.getColor())
                            .margin(0.px)
                            .toAttrs()
                    ) {
                        AnjurosText(product.price,
                            com.anjuros.website.components.language.ResKey.PLACEHOLDER_SERVICE_PRICE
                        )
                    }
                }
            }
        }

    }

}


@OptIn(DelicateApi::class)
@Composable
private fun Template5ProductsCarousel(
    category: Template5Category
) {

    val breakPoint = rememberBreakpoint()

    val scrollAmount = when {
        breakPoint >= Breakpoint.LG -> 360.0   // 320 card + 40 gap
        breakPoint >= Breakpoint.MD -> 340.0   // 300 card + 40 gap
        else -> 290.0                          // 250 card + 40 gap
    }

    val currentScroll = remember(category) { mutableStateOf(0.0) }
    val maxScroll = remember(category) { mutableStateOf(0.0) }

    val products = remember(category) {
        Template5Product.entries.filter {
            it.category == category
        }
    }

    DisposableEffect(category) {

        val container =
            document.getElementById("scrollableContainer") as? HTMLElement

        val updateScroll: (Event) -> Unit = {

            if (container != null) {

                currentScroll.value =
                    container.scrollLeft

                maxScroll.value =
                    (container.scrollWidth - container.clientWidth)
                        .toDouble()

            }
        }

        container?.addEventListener(
            "scroll",
            updateScroll
        )

        // initialise
        updateScroll(Event("scroll"))

        onDispose {

            container?.removeEventListener(
                "scroll",
                updateScroll
            )
        }
    }


    Row(
        modifier = Modifier.fillMaxWidth(),
        horizontalArrangement = Arrangement.Center,
        verticalAlignment = Alignment.CenterVertically
    ) {

        //----------------------------------------------------
        // LEFT ARROW
        //----------------------------------------------------

        Box(
            modifier = Modifier.fillMaxWidth(10.percent)
        ) {

            if (currentScroll.value > 41) {

                Template5CarouselArrow(
                    modifier = Modifier.align(
                        if (breakPoint >= Breakpoint.LG)
                            Alignment.CenterEnd
                        else
                            Alignment.CenterStart
                    ),
                    left = true
                ) {

                    (document.getElementById("scrollableContainer") as? HTMLElement)
                        ?.scrollBy(
                            ScrollToOptions(
                                left = -scrollAmount,
                                behavior = ScrollBehavior.SMOOTH
                            )
                        )
                }
            }
        }

        //----------------------------------------------------
        // PRODUCTS
        //----------------------------------------------------

        Box(
            modifier = ProductRowPercStyle.toModifier()
        ) {

            Row(

                modifier = ProductCardMaxWidthStyle.toModifier()
                    .align(Alignment.Center)
                    .id("scrollableContainer")
                    .fillMaxWidth()
                    .gap(40.px)
                    .padding(20.px)
                    .overflow(Overflow.Auto)
                    .styleModifier {

                        property(
                            "overflow-x",
                            "auto"
                        )

                        property(
                            "overflow-y",
                            "hidden"
                        )

                        property(
                            "scroll-snap-type",
                            "x mandatory"
                        )

                        property(
                            "scrollbar-width",
                            "none"
                        )

                        property(
                            "-ms-overflow-style",
                            "none"
                        )
                    },

                verticalAlignment = Alignment.Top

            ) {


                    Box(
                        modifier = Modifier.width(50.percent)
                            .displayUntil(Breakpoint.MD)
                    )


                products.forEach { product ->

                    Template5ProductCard(

                        modifier = ProductSingleCardWidthStyle
                            .toModifier()
                            .styleModifier {

                                property(
                                    "scroll-snap-align",
                                    "center"
                                )
                            },

                        product = product
                    )
                }


                Box(
                    modifier = Modifier.width(50.percent)
                        .displayUntil(Breakpoint.MD)
                )

            }
        }

        //----------------------------------------------------
        // RIGHT ARROW
        //----------------------------------------------------

        Box(
            modifier = Modifier.fillMaxWidth(10.percent)
        ) {

            if (currentScroll.value < maxScroll.value-50 ) {

                Template5CarouselArrow(
                    modifier = Modifier.align(
                        if (breakPoint >= Breakpoint.LG)
                            Alignment.CenterStart
                        else
                            Alignment.CenterEnd
                    ),
                    left = false
                ) {

                    (document.getElementById("scrollableContainer") as? HTMLElement)
                        ?.scrollBy(
                            ScrollToOptions(
                                left = scrollAmount,
                                behavior = ScrollBehavior.SMOOTH
                            )
                        )
                }
            }
        }
    }
}


@Composable
private fun Template5CarouselArrow(
    modifier: Modifier,
    left: Boolean,
    onClick: () -> Unit
) {

    Box(
        modifier =
            modifier.then(
            Template5CarouselArrowStyle.toModifier())
                .displayIfAtLeast(Breakpoint.LG)
            .size(56.px)
            .cursor(Cursor.Pointer)
            .onClick { onClick() },
        contentAlignment = Alignment.Center
    ) {

       Template5Arrow(left=left)

    }

    Box(
        modifier =modifier
                .displayUntil(Breakpoint.LG)
                .size(20.px)
                .cursor(Cursor.Pointer)
                .onClick { onClick() },
        contentAlignment = if(left) Alignment.CenterStart else Alignment.Center
    ) {

        Template5Arrow(left=left)

    }

}

@Composable
fun Template5Arrow(left: Boolean){
    Image(
        modifier = Modifier.size(18.px),
        src = if (left)
            "template5_arrow_left.svg"
        else
            "template5_arrow_right.svg",
        alt = ""
    )
}